import * as React from 'react';
import Box from '@mui/material/Box';
import { useState, useEffect } from 'react';
import Searchbar from 'src/layouts/dashboard/Searchbar';
import { Link as RouterLink } from 'react-router-dom';

// material
import {
  Card,
  Table,
  Stack,
  Avatar,
  Button,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  Modal,
  CircularProgress,
  Pagination,
  Snackbar,
  Alert,
  Tooltip
} from '@mui/material';
import { LoadingButton } from '@mui/lab';

// components
import Page from '../components/Page';
import Scrollbar from '../components/Scrollbar';
import Iconify from '../components/Iconify';
import SearchNotFound from '../components/SearchNotFound';
import { UserListHead } from '../sections/@dashboard/user';

import pallete from '../theme/palette';
import { api } from '../Api';
import { useTranslation } from 'react-i18next';
import BannerModal from 'src/sections/Bannersmodal/BannerModal';

export default function Banners() {
  const { t } = useTranslation();

  const TABLE_HEAD = [
    { id: 'heading', label: 'Heading', alignRight: false },
    { id: 'url', label: 'Url', alignRight: false },
    { id: 'action', label: 'Action', alignRight: false }
  ];
  const [permission, setpermission] = useState([]);
  const requirement = ['visible', 'add', 'edit', 'delete'];

  function checkRender() {
    let check = 'brands';
    const localPerm = JSON.parse(localStorage.getItem('permissions'))?.filter(
      (item) => item.permission_name.toLowerCase() == check
    );
    localPerm[0]?.permission_types?.filter((items) =>
      requirement.includes(items.permission_type_name.toLowerCase())
        ? setpermission((permissions) => [...permissions, items.permission_type_name.toLowerCase()])
        : false
    );
  }

  useEffect(() => {
    checkRender();
  }, []);

  const [list, setlist] = useState([]);
  const [search, setsearch] = useState('');
  const [loading, setloading] = useState(true);
  const [searchLoading, setsearchLoading] = useState(false);
  const [pagesCount, setpagesCount] = useState(1);
  const [page, setPage] = React.useState(1);
  const [alert, setalert] = useState({ visible: false, message: '' });

  const handlePageChange = (event, value) => {
    list.length = 0;
    setPage(value);
    getBrands(value);
  };

  function getBrands(page) {
    setloading(true);
    const myHeaders = new Headers();
    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);

    const searchParam = search.length > 0 ? search : null;
    const pageParam = page ? page : null;
    // search.length > 0 ? Encryption(search, process.env.REACT_APP_SECRET_KEY) : null;
    // const pageParam = page ? Encryption(page, process.env.REACT_APP_SECRET_KEY) : null;

    let url = api.get_banners;
    const params = new URLSearchParams();
    if (searchParam) params.append('search', searchParam);
    if (pageParam) params.append('page', pageParam);
    if (params.toString()) url += `?${params.toString()}`;

    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };
    // console.log('parms', params);
    fetch(url, requestOptions)
      .then((response) => {
        if (response.status === 200) {
          return response.text();
        } else {
          throw new Error('Failed to get brands');
        }
      })
      .then((result_) => {
        const result = JSON.parse(result_);
        list.length = 0;
        let decryptedData = result.data;
        setlist(decryptedData);
        result?.count ? setpagesCount(Math.ceil(result?.count / 20)) : setpagesCount(1);
      })
      .catch((error) => {
        console.log('error', error);
        setlist([]);
        setpagesCount(0);
      })
      .finally(() => {
        setloading(false);
        setsearchLoading(false);
      });
  }

  useEffect(() => {
    getBrands();
  }, []);

  const [openBrand, setopenBrand] = React.useState(false);
  const [brand, setbrand] = useState(null);

  function openBrandModal(brand) {
    setbrand(brand);
    setopenBrand(true);
  }

  const handleClosebrandModal = () => setopenBrand(false);

  const isbrandNotFound = list.length === 0;

  const style = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    alignSelf: 'center',
    width: '100%',
    height: '80%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 1,
    border: '2px solid',
    borderColor: 'primary.main',
    overflow: 'hidden'
  };

  const refreshAdmin = () => {
    setopenBrand(false);
    getBrands(page);
  };

  useEffect(() => {
    if (search.length == 0) {
      list.length = 0;
      getBrands(page);
    }
  }, [search]);

  const [selectedId, setselectedId] = useState(null);

  function DeleteBrand(id) {
    setselectedId(id);
    const token = localStorage.getItem('token');
    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);

    const requestOptions = {
      method: 'DELETE',
      headers: myHeaders,
      redirect: 'follow'
    };

    fetch(api.delete_banner + '?id=' + id, requestOptions)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          return response.json();
        } else {
          return response.json().then((result) => {
            setmessage(result.message);
            setmode('error');
            setshowSnackbar(true);
          });
        }
      })
      .then((result) => {
        setmode('success');
        setmessage(result.message);
        setshowSnackbar(true);
        refreshAdmin();
      })
      .catch((error) => {
        console.log('error', error);
      })
      .finally(() => {
        setselectedId(null);
      });
  }

  const [showSnackbar, setshowSnackbar] = useState(false);
  const [message, setmessage] = useState('');
  const [mode, setmode] = useState('error');

  return (
    <Page title={`Banners | ${process.env.REACT_APP_PROJECTNAME}`}>
      <Container>
        {/* SNACKBAR FOR DELETE */}
        <Snackbar
          open={showSnackbar}
          autoHideDuration={3000}
          onClose={() => {
            setshowSnackbar(false);
          }}
        >
          <Alert
            onClose={() => {
              setshowSnackbar(false);
            }}
            severity={mode}
            sx={{
              width: '100%',
              color: 'black'
            }}
          >
            {message}
          </Alert>
        </Snackbar>
        {/* EDIT brand */}
        <Modal
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            width: '100%'
          }}
          open={openBrand}
          onClose={handleClosebrandModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              maxWidth: '60%',
              maxHeight: '90%',
              bgcolor: 'background.paper',
              boxShadow: 24,
              overflow: 'auto',
              p: 1,
              border: '2px solid',
              borderColor: 'primary.main',
              flex: 1,
              style
            }}
            className="admin_modal_pa"
          >
            <BannerModal
              product={brand}
              handleClose={handleClosebrandModal}
              refreshAdmin={refreshAdmin}
            />
          </Box>
        </Modal>

        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
          <Typography variant="h4" gutterBottom>
            Banners
          </Typography>
          {permission.includes('add') && (
            <Button
              onClick={() => {
                openBrandModal(null);
              }}
              variant="contained"
              component={RouterLink}
              to="#"
              startIcon={<Iconify icon="eva:plus-fill" />}
            >
              Add
            </Button>
          )}
        </Stack>

        <Card>
          <Box
            p={2}
            style={{
              flexDirection: 'row',
              display: 'flex',
              flex: 1
            }}
            className="top_column"
          >
            <Searchbar
              width={'90%'}
              value={search}
              setFunction={(val) => {
                setsearch(val);
              }}
              className="width_full_property"
              placeholder={t('Agents.search')}
              onEnter={() => {
                setsearchLoading(true);
                list.length = 0;
                getBrands();
              }}
            />

            <LoadingButton
              style={{ width: '15%', marginLeft: '2.5%' }}
              variant="contained"
              loading={searchLoading}
              onClick={() => {
                setsearchLoading(true);
                setPage(1);
                getBrands(1);
              }}
              className="width_full_status"
            >
              {' '}
              <Iconify icon="material-symbols:search" sx={{ width: 25, height: 25 }} />
            </LoadingButton>
          </Box>

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <UserListHead headLabel={TABLE_HEAD} rowCount={list.length} />
                <TableBody>
                  {list.map((row) => {
                    const { id, heading, url, media } = row;

                    return (
                      <TableRow
                        hover
                        onClick={() => { }}
                        style={{
                          backgroundColor: 'transparent',
                          cursor: 'default'
                        }}
                        key={id}
                        tabIndex={-1}
                        role="checkbox"
                      >
                        {/* <TableCell scope="row" padding="normal" style={{ width: 250 }}>
                        <Stack direction="row" alignItems="center" spacing={1}>
                            <Avatar
                              alt={name}
                              src={
                                media?.length > 0
                                  ? media[0]?.uri
                                  : 'https://media.istockphoto.com/id/1128229893/vector/shopping-cart-icon.jpg?s=612x612&w=0&k=20&c=EunmrZqRD5SXHNtqUBNkDl0zJGgq7QUjw2KXlbR6_Dg='
                              }
                              style={{ width: 50, height: 50, borderRadius: 0 }}
                            />  
                            <div className="one-line-ellipsis">{name}</div>
                          </Stack>
                        </TableCell> */}

                        <TableCell scope="row" padding="normal">
                          <Stack
                            direction="row"
                            alignItems="center"
                            spacing={1}
                            style={{ width: 150 }}
                          >
                            <Avatar
                              alt={media}
                              src={
                                media?.length > 0
                                  ? media
                                  : 'https://media.istockphoto.com/id/1128229893/vector/shopping-cart-icon.jpg?s=612x612&w=0&k=20&c=EunmrZqRD5SXHNtqUBNkDl0zJGgq7QUjw2KXlbR6_Dg='
                              }
                              style={{ width: 50, height: 50, borderRadius: 0 }}
                            />
                            <Box style={{ display: 'flex', flexDirection: 'column', width: 120 }}>
                              <Typography variant="subtitle2" flexWrap={'wrap'}>
                                {heading || 'N/A'}
                              </Typography>
                            </Box>
                          </Stack>
                        </TableCell>

                        <TableCell scope="row" padding="normal">
                          <Stack
                            direction="row"
                            alignItems="center"
                            spacing={1}
                            style={{ width: 150 }}
                          >
                            {/* <Avatar alt={name} src={avatar + '?v=' + Date.now()} /> */}
                            <Box style={{ display: 'flex', flexDirection: 'column', width: 120 }}>
                              <Typography variant="subtitle2" flexWrap={'wrap'}>
                                {url || 'N/A'}
                              </Typography>
                            </Box>
                          </Stack>
                        </TableCell>

                        <TableCell align="left">
                          {permission.includes('edit') && (
                            // <Button
                            //   size="small"
                            //   onClick={() => openBrandModal(row)}
                            //   style={{
                            //     justifyContent: 'flex-start',
                            //     alignSelf: 'center',
                            //     marginRight: 5
                            //   }}
                            //   variant="outlined"
                            //   component={RouterLink}
                            //   to="#"
                            //   startIcon={
                            //     <Iconify color={pallete.primary.main} icon="solar:user-id-bold" />
                            //   }
                            // >
                            //   Edit
                            // </Button>
                            <Tooltip title="Edit">
                              <LoadingButton
                                size="small"
                                onClick={() => openBrandModal(row)}
                                style={{
                                  justifyContent: 'center',
                                  width: 30, // Less than 30
                                  height: 30, // Ensuring it's a square button
                                  minWidth: 30, // Ensuring minimum width is set to 30
                                  padding: 0, // Removing padding to fit the icon properly
                                  lineHeight: 1, // Ensuring the icon is centered
                                  alignSelf: 'center',
                                  marginLeft: 1
                                }}
                                component={RouterLink}
                                to="#"
                              >
                                <Iconify style={{ cursor: 'pointer', fontSize: 22 }} icon="solar:user-id-bold" />
                              </LoadingButton>
                            </Tooltip>
                          )}
                          {permission.includes('delete') && (
                            // <>
                            //   <LoadingButton
                            //     size="small"
                            //     onClick={() => DeleteBrand(id)}
                            //     style={{
                            //       justifyContent: 'flex-start',
                            //       alignSelf: 'center'
                            //     }}
                            //     variant="outlined"
                            //     loading={selectedId == id}
                            //     startIcon={
                            //       <Iconify
                            //         color={pallete.primary.main}
                            //         icon="material-symbols:delete"
                            //       />
                            //     }
                            //   >
                            //     Delete
                            //   </LoadingButton>
                            // </>
                            <Tooltip title="Delete">
                              <LoadingButton
                                size="small"
                                onClick={() => DeleteBrand(id)}
                                style={{
                                  justifyContent: 'center',
                                  width: 30, // Less than 30
                                  height: 30, // Ensuring it's a square button
                                  minWidth: 30, // Ensuring minimum width is set to 30
                                  padding: 0, // Removing padding to fit the icon properly
                                  lineHeight: 1, // Ensuring the icon is centered
                                  alignSelf: 'center',
                                  marginLeft: 1
                                }}
                                loading={selectedId == id}
                                component={RouterLink}
                                to="#"
                              >
                                <Iconify style={{ cursor: 'pointer', fontSize: 20 }} icon="material-symbols:delete" />
                              </LoadingButton>
                            </Tooltip>
                          )}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>

                {isbrandNotFound && !loading && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={search} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
              {loading && !searchLoading && (
                <Box
                  py={5}
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    flex: 1
                  }}
                >
                  <CircularProgress />
                </Box>
              )}
            </TableContainer>
          </Scrollbar>
        </Card>
        {!loading && !searchLoading && pagesCount > 1 && (
          <Box
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-end',
              marginTop: 10,
              alignItems: 'center'
            }}
          >
            <Pagination
              count={pagesCount}
              color="primary"
              variant="outlined"
              shape="rounded"
              onChange={handlePageChange}
              page={page}
            />
          </Box>
        )}
      </Container>
    </Page>
  );
}
